import { type IconifyProps } from '../../../components/iconify/types';

const Webkommunikation24Logo: IconifyProps = {
    body: `<g transform="matrix(1.34454,0,0,1.34454,-130.42,-115.641)">
        <path d="M405,252L448,123L535.612,123.087L535,125L448,386L360,386.366L405,252Z" style="fill:rgb(236,63,63);fill-rule:nonzero;"/>
        <path d="M536,104L536,86L573,86L573,123L554,123L536,104ZM229,253L273,123L314,244L316,256L279,366L227,262L229,253Z" style="fill:rgb(236,63,63);fill-opacity:0.4;fill-rule:nonzero;"/>
        <path d="M402,248L405,252L360,386.366L316,256L314,244L361.261,123.329L388,207L402,248Z" style="fill:rgb(236,63,63);fill-opacity:0.6;"/>
        <path d="M185,386.404L97,123L185,123L229,253L227,262L221,280L185,386.404Z" style="fill:rgb(236,63,63);fill-opacity:0.2;fill-rule:nonzero;"/>
        <path d="M535.787,122.946L536,104L554,123L535.787,122.946ZM314,244L273,123L361.272,123.332L314,244Z" style="fill:rgb(236,63,63);fill-opacity:0.8;fill-rule:nonzero;"/>
        <path d="M221,280L268.164,386.492L185,386.349L221,280ZM221,280L227,262L279,366L268,386L221,280Z" style="fill:rgb(236,63,63);fill-opacity:0.5;"/>
    </g>`,
    height: 404,
    width: 640,
};

export default Webkommunikation24Logo;
